import React from 'react'
import { Paper, Typography } from '@mui/material'


type RiskPanelProps = {
  title: string
  content: string
  backgroundColor: string
  color: string
}

export const RiskPanel = ({ title, content, backgroundColor, color }: RiskPanelProps) => {
  return (
    <>
      <Paper variant='outlined' sx={{
        backgroundColor: backgroundColor,
        color: color,
        fontSize: 18,
        fontWeight: 'bold',
        padding: 1,
        mt: 3
      }}>
        { title }
      </Paper>
      <Typography sx={{ fontSize: 14, textAlign: 'left', whiteSpace: 'pre-wrap', mt: 1 }} color="text.secondary">
        { content }
      </Typography>
    </>
  )
}
